/**
 * CR310: S0 Scan Settings v2 - Deal Locator Tab (Tab 4)
 * Deep keyword scan and extraction focus configuration
 */

import { Search, Crosshair } from 'lucide-react';
import { S0DealLocatorSection } from '../../S0DealLocatorSection';
import type { BatchRunFlyerConfig } from '../types';
import type {
  DealLocatorConfig,
  TiledScanningConfig,
  ExtractionFocusConfig,
} from '@/lib/flyer-pipeline-v2/dealLocatorTypes';

interface DealLocatorTabProps {
  config: BatchRunFlyerConfig;
  updateConfig: <K extends keyof BatchRunFlyerConfig>(key: K, value: BatchRunFlyerConfig[K]) => void;
  disabled?: boolean;
}

export function DealLocatorTab({
  config,
  updateConfig,
  disabled = false,
}: DealLocatorTabProps) {
  return (
    <div className="space-y-4">
      <div className="flex items-center gap-2 text-sm font-medium text-muted-foreground">
        <Search className="h-4 w-4" />
        Deal Locator — Deep Keyword Scan
      </div>
      
      <S0DealLocatorSection
        locatorConfig={config.dealLocator}
        tiledConfig={config.tiledScanning}
        extractionConfig={config.extractionFocus}
        onLocatorConfigChange={(c: DealLocatorConfig) => updateConfig('dealLocator', c)}
        onTiledConfigChange={(c: TiledScanningConfig) => updateConfig('tiledScanning', c)}
        onExtractionConfigChange={(c: ExtractionFocusConfig) => updateConfig('extractionFocus', c)}
        disabled={disabled}
      />
    </div>
  );
}
